@if (banners$ | async; as banners) {
    <app-main-slider [banners]="banners"></app-main-slider>
}
